import { ToolOutlined } from '@ant-design/icons';
import { Card, Typography } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const HandlerDashboardSettings: FC = () => {
  const { t } = useTranslation('settings.HandlerDashboardSettings');

  return (
    <Card>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '60px 20px',
          textAlign: 'center',
        }}
      >
        <ToolOutlined
          style={{ fontSize: 40, color: '#999', marginBottom: 16 }}
        />
        <Title level={4}>{t('title')}</Title>
        <Text type="secondary">{t('comingSoon')}</Text>
      </div>
    </Card>
  );
};

export default HandlerDashboardSettings;
